/* jshint esnext: true */
import AbstractModule from './AbstractModule';
import {$document} from '../utils/environment';
import {scrollTo} from '../global/scrollTo';

var defaultOptions = {
    parentClass  : 'js-dropdown',
    toggleClass  : 'js-dropdown-toggle',
    contentClass : 'js-dropdown-content',
    openClass    : 'is-open',
    disabledClass: 'is-disabled',
    mode         : null,
    scrollto     : false,
    speed        : 400,
    maxWidth     : false,
    minWidth     : false
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
        var paramOptions = {};

        for (var prop in options) {
            if (prop.indexOf('dropdown') !== -1) {

                if (prop === 'dropdown-scrolltoparent' && typeof options[prop] === 'string') {
                    paramOptions['scrolltoParent'] = $(options[prop]);
                    if (options[prop] === '.js-parent-search') {
                        paramOptions['isSearch'] = true;
                    }
                } else {
                    paramOptions[prop.replace('dropdown-', '')] = options[prop];
                }
            }
        }

        this.options = $.extend({}, defaultOptions, paramOptions);

        this.$el.on('click.Dropdown', '.' + this.options.toggleClass, (event) => {
            this.manageDropdownClick(event);
        });
    }

    manageDropdownClick(event) {
        var $target = $(event.currentTarget);
        var $parent = $target.parents('.' + this.options.parentClass).eq(0);

        event.preventDefault();

        if (this.options.maxWidth !== false) {
            if (!window.matchMedia('(max-width: ' + this.options.maxWidth + 'px)').matches) {
                return false;
            }
        }

        if (this.options.minWidth !== false) {
            if (!window.matchMedia('(min-width: ' + this.options.minWidth + 'px)').matches) {
                return false;
            }
        }

        if ($target.hasClass(this.options.disabledClass)) {
            return false;
        }

        if (this.options.mode === 'accordion') {
            $parent
                .siblings('.' + this.options.parentClass)
                .removeClass(this.options.openClass)
                .find('.' + this.options.contentClass)
                .stop()
                .slideUp(this.options.speed);
        }

        $parent.toggleClass(this.options.openClass);
        $target
            .siblings('.' + this.options.contentClass)
            .stop()
            .slideToggle(this.options.speed);

        if (this.options.scrollto && $parent.hasClass(this.options.openClass)) {
            setTimeout(() => {
                if (this.options.scrolltoParent !== undefined) {
                    scrollTo($parent, {
                        $container: this.options.scrolltoParent,
                        isSearch: this.options.isSearch || false,
                    });
                } else {
                    $document.trigger({
                        type:'goTo.Scroll',
                        target: event.currentTarget
                    });
                }
            }, 400);
        }

        setTimeout(()=>{
            $document.trigger({
                type:'update.Scroll',
                scrollTop:false
            });
        },600);
    }

    closeAllWithin() {
        this.$el.find('.' + this.options.parentClass)
            .removeClass(this.options.openClass)
            .find('.' + this.options.contentClass)
            .stop()
            .slideUp(this.options.speed);
    }

    destroy() {
        this.$el.off('.Dropdown');
    }
}
